import { CookieUtil } from "./module/cookie-util";
import DateTimeUtil from "./util/DateTimeUtil";

/**
 * mh_utm_paramsクッキーから全UTMパラメータを取得し、Treasure Dataのすべてのテーブルに追加
 */
function setTdEventGlobalPropsForUtmParams(): void {
    const _isDev = (location.hostname != 'myhome.nifty.com');
    try {
        const mhUtmParamsCookie = CookieUtil.getMhUtmParamsCookieValue();
        if (!mhUtmParamsCookie?.utm_params) {
          if (_isDev) {
            console.log("[UTM Params to TD] mh_utm_params cookie not found.");
          }
            return;
        }

    // datetime を JST 形式に変換
    let jstDatetimeStr: string | undefined;
    if (mhUtmParamsCookie.datetime) {
      jstDatetimeStr = DateTimeUtil.utcUnixtimeToJstIso8601(mhUtmParamsCookie.datetime);
    }

    const params = {
      mh_utm_datetime: jstDatetimeStr,
      mh_utm_uri: mhUtmParamsCookie.uri,
      mh_utm_source: mhUtmParamsCookie.utm_params?.utm_source,
      mh_utm_medium: mhUtmParamsCookie.utm_params?.utm_medium,
      mh_utm_campaign: mhUtmParamsCookie.utm_params?.utm_campaign,
      mh_utm_term: mhUtmParamsCookie.utm_params?.utm_term,
      mh_utm_content: mhUtmParamsCookie.utm_params?.utm_content,
    };

    // Treasure Dataのすべてのテーブルに追加
    window.MyhomeTDM.Treasure.set("$global", params);
    if (_isDev) {
      console.log("[UTM Params to TD] Set UTM parameters:", params);
    }
  } catch (e) {
    if (_isDev) {
      console.error("[UTM Params to TD] Error setting UTM parameters:", e);
    }
  }
}

// ページ読み込み時にUTMパラメータをTreasure Dataに送信
setTdEventGlobalPropsForUtmParams();
